import { useEffect } from 'react';

export function useFocusSanitizer() {
  useEffect(() => {
    const handleFocusIn = (event: FocusEvent) => {
      const active = event.target as HTMLElement;
      if (!active) return;

      let el: HTMLElement | null = active;
      while (el) {
        if (el.getAttribute?.('aria-hidden') === 'true') {
          requestAnimationFrame(() => {
            if (document.activeElement === active) {
              active.blur();
            }
          });
          break;
        }
        el = el.parentElement;
      }
    };

    window.addEventListener('focusin', handleFocusIn, true);

    return () => {
      window.removeEventListener('focusin', handleFocusIn, true);
    };
  }, []);
}
